import React, { ChangeEvent, useMemo } from 'react';
import { ErrorMessage } from '../ErrorMessage';

import './styles.scss';

interface Props {
    value: string;
    className?: string;
    disabled?: boolean;
    errors?: string[];
    hideErrorMessage?: boolean;
    placeholder?: string;
    removeBorderRadius?: 'top' | 'bottom';
    maxLength?: number;
    type?: 'text' | 'email' | 'number';
    inputmode?: 'text' | 'numeric';
    tabIndex?: number;
    onChange: (value: string) => void;
}

export const Input = ({
    value,
    className = '',
    disabled,
    errors,
    hideErrorMessage,
    placeholder,
    removeBorderRadius,
    maxLength,
    type = 'text',
    inputmode = 'text',
    tabIndex,
    onChange,
}: Props) => {
    const borderRadiusClassName = useMemo(() => {
        switch (removeBorderRadius) {
            case 'top':
                return 'app-input__input--no-top-border';
            case 'bottom':
                return 'app-input__input--no-bottom-border';
            default:
                return '';
        }
    }, [removeBorderRadius]);

    const hasError = useMemo(() => errors && !!errors.length, [errors]);

    const symbolCounter = useMemo(() => {
        if (!maxLength) {
            return null;
        }

        return (
            <div className='app-input__symbol-count'>
                {maxLength - value.length}/{maxLength}
            </div>
        );
    }, [value, maxLength]);

    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const trimmedValue = e.target.value.trimStart();
        onChange(trimmedValue);
    };

    return (
        <div className={`app-input ${className}`}>
            <input
                name='name'
                type={type}
                inputMode={inputmode}
                autoComplete='off'
                className={`app-input__input ${hasError ? 'app-input__input--has-error' : ''} ${borderRadiusClassName}`}
                value={value}
                placeholder={placeholder}
                disabled={disabled}
                tabIndex={tabIndex}
                onChange={onInputChange}
            />
            <div className='app-input__additional-data-wrap'>
                {!hideErrorMessage && <ErrorMessage errors={errors} />}
                {symbolCounter}
            </div>
        </div>
    );
};
